<div [class.comment-reply]="isreply" [class.comment-box]="!isreply" class="comments-container"  [id]="'c'+ comment.commentid">
    <div class="header">
        <div class="author-box">
            <div class="author-avatar">
              <unh-user-avatar
                [avatarUrl]="userAvatarUrl"
                [username]="comment.authorusername"
                [uid]="comment.authoruid"
                [userSubscribed]="comment.authorsubscribed"
                [hasUnreadNotifs]="false"
                [redirectToProfile]="true"
                [defaultAvatarUrl]="defaultAvatarUrl"
              ></unh-user-avatar>
            </div>

            <span class="name">
                {{comment.authoralias}}
            </span>
        </div>

        <div class="time-box">
            <div
              class="options-container"
              *ngIf="luss.isLogged && (isAuthor || luss.isAdmin)"
            >
              <button (click)="editInPlace()">
                <mat-icon>create</mat-icon>
              </button>
              <button (click)="handleRemoveComment()">
                <mat-icon>delete_outline</mat-icon>
              </button>
            </div>
            <mat-icon>access_time</mat-icon>
            <span>{{comment.date}}</span>
        </div>
    </div>

    <div class="edit-container">
        <!-- <textarea
          #textEdit
          class="input-edit"
          matInput
          cdkTextareaAutosize
          cdkAutosizeMinRows="1"
          cdkAutosizeMaxRows="5"
        >
            {{ comment.message }}
        </textarea> -->

        <div
        class="comment-wrapper"
        [class.readonly]="!editMode"
        >
          <!-- <quill-editor
          #commentQuill = "ngModel"
          #quillInstance
          [modules]="QuillModules"
          [readOnly]="!editMode"
          [placeholder]="'Comece a digitar aqui...'"
          [maxLength]="1000"
          [(ngModel)]="note"
          [trimOnValidation]="true"
          (onEditorCreated)="initCommentContent($event, comment.message)"
          (onEditorChanged)="onMessageChanged($event)"
          ></quill-editor> -->
          <unh-comment-quill-editor
          [readonly]="!editMode"
          (onImagesChanged)="onImagesChanged($event)"
          (onEditorChanged)="onMessageChanged($event)"
          (onEditorCreated)="initCommentContent($event, comment.message)"
          ></unh-comment-quill-editor>

        </div>
        <div class="comment-actions" *ngIf="editMode">
            <a
                mat-button
                theme="white-pink-outline"
                class="unh-button-old cancel"
                (click)="cancelEdit()"
            >
                Cancelar
            </a>
            <a
              mat-button
              theme="pink-white"
              class="unh-button-old submit"
              [disabled]="submitDisabled"
              (click)="!submitDisabled ? handleEditComment() : null"
            >
              Atualizar
            </a>
        </div>
        <!-- <div class="btn-edit" *ngIf="editMode">
            <button
              class="transparent"
              mat-fab
              aria-label="buttonType.arialabel"
              (click)="handleEditComment()"
            >
                <mat-icon>send</mat-icon>
            </button>
        </div> -->

    </div>



    <!-- <div class="body" *ngIf="!editMode" [innerHTML]="comment.message"></div> -->

    <!-- COMMENTS FOOTER -->
    <div class="footer" *ngIf="!editMode && luss.isLogged">
        <div class="footer-option" [class.active]="replyOpen" (click)="toggleReply()">
            <a>Responder</a>
            <mat-icon>reply</mat-icon>
        </div>

        <!-- <div class="footer-option" [class.active]="comment.userliked" (click)="toggleLike()">
            <a>curtir comentário</a>
            <mat-icon>favorite</mat-icon>
        </div> -->

    </div>
    <unh-comment-box-reply
        *ngIf="replyOpen"
        (replySubmitted)="onReplySubmitted($event)"
        (closeReplyInput)="toggleReply()"
        ></unh-comment-box-reply>

</div>
